import {Component, Input, OnInit} from '@angular/core';
import {SensorEventActuator, SensorEventActuatorType} from "../../ParseClass/SensorEvent.Parse";
import {ElementParse} from "../../ParseClass/Element.Parse";
import {arrayIsSet, stringIsSet} from "../../providers/service/global-variables.service";
import {Light, LightStatus, LightType} from "../../ParseClass/light";
import {Shutter, ShutterStatus, ShutterType} from "../../ParseClass/shutter";
import {IconService} from "../../providers/service/icon.service";
import {DevicesDividedForCategory} from "../../providers/service/sensor-event-page.service";
import {Switch, SwitchStatus} from "../../ParseClass/switch";
import {Command} from "../../ParseClass/command";
import {LinearActuator} from "../../ParseClass/linear-actuator";

@Component({
    selector: 'app-box-actuators',
    templateUrl: './box-actuators.component.html',
    styleUrls: ['./box-actuators.component.scss'],
    standalone: false
})
export class BoxActuatorsComponent implements OnInit {
    @Input() actuator: SensorEventActuator | undefined
    @Input() elements: ElementParse[] | undefined
    @Input() lights: Light[] | undefined
    @Input() shutters: Shutter[] | undefined
    @Input() switches: Switch[] | undefined
    @Input() commands: Command[] | undefined
    @Input() linearActuators: LinearActuator[] | undefined
    sensorEventActuatorType = SensorEventActuatorType
    lightType = LightType;
    shutterType = ShutterType;

    constructor(private iconService: IconService) {
        this.iconService.addSvgIcon('external_sensor', 'assets/icon/sensor/external_sensor.svg')
        this.iconService.addSvgIcon('blinds', 'assets/icon/sensor/blinds.svg')
        this.iconService.addSvgIcon('bulbs', 'assets/icon/sensor/bulbs.svg')
    }

    ngOnInit(): void {
    }


    predicateGetElementExternal(
        value: {
            sourceSensorId: string;
            sourceInfoName: string;
            targetElementId: string;
            targetCommandName: string;
        },
        elements: ElementParse[] | undefined
    ): {
        target?: ElementParse,
        sensor?: ElementParse,
        targetCommandName?: string,
        sourceInfoName?: string
    } | undefined {
        if (value == null || !arrayIsSet(elements) || (!stringIsSet(value.sourceSensorId) && !stringIsSet(value.targetElementId))) {
            return undefined
        } else {
            let target;
            let sensor;
            const sourceInfoName = value.sourceInfoName;
            const targetCommandName = value.targetCommandName;
            target = elements.find((e: ElementParse) => e.objectId === value.targetElementId)
            sensor = elements.find((e: ElementParse) => e.objectId === value.sourceSensorId)
            return {target, targetCommandName, sensor, sourceInfoName}
        }
    }

    predicateColorIcon(value: any): string | undefined {
        if (value == null || value.config == null) {
            return undefined
        } else {
            return value.config.isOn == true ? 'primary' : undefined
        }
    }

    predicateColorIconSwitch(value: any): string | undefined {
        if (value == null || value.config == null) {
            return undefined
        } else {
            return value.config.status == SwitchStatus.ON ? 'primary' : undefined
        }
    }

    predicateRelayTraduction(value: any): string | undefined {
        if (value == null || value.config == null) {
            return undefined
        } else {
            return value.config.status == SwitchStatus.ON ? 'SensorEvent.actived' : 'SensorEvent.notActived'
        }
    }

    predicateGetSwitch(value: any, switches: Switch[], ndName: string): Switch | undefined {
        if (value == null || !arrayIsSet(switches)) {
            return {name: ndName} as any
        } else {
            const switch_ = switches.find(s => s.objectId === value.objectId)
            return switch_ == null ? value as Switch : switch_;
        }
    }

    predicateGetLight(value: any, lights: Light[]): Light | undefined {
        if (value == null) {
            return undefined
        } else {
            let light = lights?.find(s => s.objectId === value.objectId)
            if (light == null) {
                light = Light.build(value)
                light.name = value.objectId
            } else {
                light = Light.build(light)
            }
            light.level = value.level
            light.status = value.status
            light.type = value.type

            return light
        }
    }

    predicateGetShutter(value: any, shutters: Shutter[]): Shutter | undefined {
        if (value == null) {
            return undefined
        } else {
            let shutter = shutters?.find(s => s.objectId === value.objectId)
            if (shutter == null) {
                shutter = Shutter.build(value)
                shutter.name = value.objectId
            } else {
                shutter = Shutter.build(shutter)
            }
            shutter.level = value.level
            shutter.status = value.status
            shutter.type = value.type
            return shutter;
        }
    }

    predicateGetCommand(value: any, commands: Command[]): Command | undefined {
        if (value == null) {
            return undefined
        } else {
            let command = commands?.find(s => s.objectId === value.objectId)
            if (command == null) {
                command = Command.build(value)
                command.name = value.objectId
            } else {
                command = Command.build(command)
            }
            command.possibleCommand = value.command
            command.value = value.value
            return command;
        }
    }

    predicateColorTypeLight(value: any): boolean {
        if (value == null || value.config == null) {
            return false;
        } else {
            const light = value.config as Light;
            return (light.status === LightStatus.ON || (light.level != null && light.level > 0));
        }
    }

    predicateColorTypeShutter(value: any): boolean {
        if (value == null || value.config == null) {
            return false;
        } else {
            const shutter = value.config as Shutter;
            return (shutter.status === ShutterStatus.UP || (shutter.level != null && shutter.level > 0));
        }

    }

    predicateGetLinearActuator(value: any): LinearActuator | undefined {
        if (value == null) {
            return undefined
        } else {
            return value;
        }
    }


    protected readonly Light = Light;
    protected readonly Shutter = Shutter;
    protected readonly Object = Object;
}

